import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';

const initialState = {
    networkThread: {},
    networkThreadSuccess: false,
    networkThreadFail: false,
    networkThreadLoading: false,
    networkThreadLoaded: false,
    radioStatus: null,
    radioStatusLoading: false,
    radioStatusFail: false,
    radioStatusLoaded: false,
    toggleLoading: false,
    toggleSuccess: false,
    toggleFail: false,
    toggleErrorType: null,
    threadInitialLoadFailed: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_NETWORK_THREAD_LOADING:
            return updateObject(state, {
                networkThread: {},
                networkThreadLoading: true
            });
        case actionTypes.GET_NETWORK_THREAD_SUCCESS:
            return updateObject(state, {
                networkThread: action.payload || {},
                networkThreadLoading: false,
                networkThreadSuccess: true,
                networkThreadLoaded: true
            });
        case actionTypes.GET_NETWORK_THREAD_FAIL:
            return updateObject(state, {
                networkThread: {},
                networkThreadFail: true,
                networkThreadLoading: false
            });
        case actionTypes.RESET_NETWORK_THREAD_ERROR_SUCCESS:
            return updateObject(state, {
                networkThreadSuccess: false,
                networkThreadFail: false,
                toggleSuccess: false,
                toggleFail: false
            });
        case actionTypes.GET_THREAD_RADIO_STATUS_LOADING:
            return updateObject(state, {
                radioStatusLoading: true,
                radioStatusFail: false
            });
        case actionTypes.GET_THREAD_RADIO_STATUS_SUCCESS:
            return updateObject(state, {
                radioStatus: action.payload || {},
                radioStatusLoading: false,
                radioStatusFail: false,
                radioStatusLoaded: true
            });
        case actionTypes.GET_THREAD_RADIO_STATUS_FAIL:
            return updateObject(state, {
                radioStatusLoading: false,
                radioStatusFail: true
            });
        case actionTypes.TOGGLE_NETWORK_THREAD_LOADING:
            return updateObject(state, {
                toggleLoading: true,
                toggleSuccess: false,
                toggleFail: false
            });
        case actionTypes.TOGGLE_NETWORK_THREAD_SUCCESS:
            return updateObject(state, {
                toggleLoading: false,
                toggleSuccess: true
            });
        case actionTypes.TOGGLE_NETWORK_THREAD_FAIL:
            return updateObject(state, {
                toggleLoading: false,
                toggleFail: true,
                toggleErrorType: action.errorType || 'SERVICE_ERROR'
            });
        case actionTypes.THREAD_INITIAL_LOAD_FAILED:
            return updateObject(state, {
                threadInitialLoadFailed: true
            });
        default: return state;
    }
};
export default reducer;
